import * as Yup from "yup";

export const FormRegistrarEmpresaScheme = () => {
    return Yup.object().shape({
        nombre: Yup.string()
            .required("El campo es requerido")
            .trim(),
        telefono: Yup.string()
            .required("El campo es requerido")
            .trim(),
        correo: Yup.string()
            .email("Correo inválido")
            .required("El campo es requerido")
            .trim(),
        empresa: Yup.string()
            .required("El campo es requerido")
            .trim(),
    });
};